/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaxRateWithAmount
 */
export interface TaxRateWithAmount {
    /**
     * 
     * @type {string}
     * @memberof TaxRateWithAmount
     */
    name: string;
    /**
     * decimal rate like 0.20
     * @type {number}
     * @memberof TaxRateWithAmount
     */
    rate: number;
    /**
     * computed tax amount
     * @type {number}
     * @memberof TaxRateWithAmount
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof TaxRateWithAmount
     */
    type?: TaxRateWithAmountTypeEnum;
}


/**
 * @export
 */
export const TaxRateWithAmountTypeEnum = {
    Vat: 'VAT',
    Other: 'OTHER'
} as const;
export type TaxRateWithAmountTypeEnum = typeof TaxRateWithAmountTypeEnum[keyof typeof TaxRateWithAmountTypeEnum];


/**
 * Check if a given object implements the TaxRateWithAmount interface.
 */
export function instanceOfTaxRateWithAmount(value: object): value is TaxRateWithAmount {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rate' in value) || value['rate'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function TaxRateWithAmountFromJSON(json: any): TaxRateWithAmount {
    return TaxRateWithAmountFromJSONTyped(json, false);
}

export function TaxRateWithAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxRateWithAmount {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'rate': json['rate'],
        'amount': json['amount'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function TaxRateWithAmountToJSON(value?: TaxRateWithAmount | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'rate': value['rate'],
        'amount': value['amount'],
        'type': value['type'],
    };
}

